import { fork } from 'redux-saga/effects';

import { saga as articleCollectionsSaga } from './article.collections';
import { saga as bookmarksSaga } from './bookmarks';
import { saga as collectionSyncSaga } from './collection.sync';
import { saga as issuePageSetSaga } from './issue.pageset';
import { saga as userCollectionsSaga } from './user.collections';

function* saga() {
    yield fork(issuePageSetSaga);
    yield fork(userCollectionsSaga);
    yield fork(articleCollectionsSaga);
    yield fork(bookmarksSaga);
    yield fork(collectionSyncSaga);
}

export { saga };
export { removeArticleFromCollectionsSaga, upsertArticleCollectionsSaga } from './article.collections/article.collections.loaders';
export { waitUntilArticleCollectionsLoaded } from './article.collections/article.collections.utils';
export { addBookmarkSaga } from './bookmarks/bookmarks.loaders';
export {
    removePageSetFromCollectionsSaga,
    updateIssuePageSetByIdSaga,
    upsertIssuePageSetCollectionSaga,
} from './issue.pageset/issue.pageset.loaders';
export { waitUntilPageSetLoaded } from './issue.pageset/issue.pageset.utils';
